var _defs, _g, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    width: 126,
    height: 126
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect818",
    fill: "#f5f6f8",
    strokeWidth: 0,
    d: "M0 0h126v126H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.45 7.1h77.1v111.8h-77.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.55 7.1h39.3v111.8h-39.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.75 35.5h8.4v20.1h-8.4zM58.75 70.8h8.4v20.1h-8.4zM58.75 7.1h8.4v13.434h-8.4zM58.75 105.466h8.4V118.9h-8.4z"
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iRWJlbmVfMSIgZGF0YS1uYW1lPSJFYmVuZSAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjYiIGhlaWdodD0iMTI2IiB2aWV3Qm94PSIwIDAgMTI2IDEyNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2Y1ZjZmODsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiBub25lOwogICAgICAgIHN0cm9rZTogIzIxMjUyOTsKICAgICAgICBzdHJva2UtbWl0ZXJsaW1pdDogMTA7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAycHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJsYXllcjIiPgogICAgPHJlY3QgaWQ9InJlY3Q4MTgiIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjEyNiIgaGVpZ2h0PSIxMjYiLz4KICA8L2c+CiAgPGc+CiAgICA8cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjI0LjQ1IiB5PSI3LjEiIHdpZHRoPSI3Ny4xIiBoZWlnaHQ9IjExMS44Ii8+CiAgICA8cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjQzLjU1IiB5PSI3LjEiIHdpZHRoPSIzOS4zIiBoZWlnaHQ9IjExMS44Ii8+CiAgICA8cmVjdCBjbGFzcz0iY2xzLTIiIHg9IjU4Ljc1IiB5PSIzNS41IiB3aWR0aD0iOC40IiBoZWlnaHQ9IjIwLjEiLz4KICAgIDxyZWN0IGNsYXNzPSJjbHMtMiIgeD0iNTguNzUiIHk9IjcwLjgiIHdpZHRoPSI4LjQiIGhlaWdodD0iMjAuMSIvPgogICAgPHJlY3QgY2xhc3M9ImNscy0yIiB4PSI1OC43NSIgeT0iNy4xIiB3aWR0aD0iOC40IiBoZWlnaHQ9IjEzLjQzNCIvPgogICAgPHJlY3QgY2xhc3M9ImNscy0yIiB4PSI1OC43NSIgeT0iMTA1LjQ2NiIgd2lkdGg9IjguNCIgaGVpZ2h0PSIxMy40MzQiLz4KICA8L2c+Cjwvc3ZnPg==";
export { SvgComponent as ReactComponent };